import angular from 'angular';
import { User } from '@common/model/user';
import _ from 'lodash';
import { TeamTypeEnum } from '@common/model/subject';
import { WorkflowActions } from '@common/model/form';
export class FormWorkflowController {
    allTeams;
    existingTeam;
    showLoader;
    providers: User[];
    workflowActionEnum: any;
    ldIncludes;
    currentUser;
    crntUserProvider: boolean = false;
    teamsFilter;

    static $inject = ['CacheService', 'DocumentFolderService', '$uibModalInstance', 'ApiAdapterService',
        'SubjectService', 'PushNotificationService', 'assgnId', 'subjectId', 'wkflTitle',
        'wkflText', 'workflowActionEnumValue', 'submitLabel', 'cancelLabel', 'cancelText', 'additionalParams', 'BroadcastService'];
    membersLoading: boolean;
    constructor(private CacheService, private DocumentFolderService, private $uibModalInstance,
        private $_api, private SubjectService, private PushNotificationService,
        private assgnId, private subjectId, private wkflTitle, private wkflText,
        private workflowActionEnumValue, private submitLabel, private cancelLabel,
        private cancelText, private additionalParams, private BroadcastService) {

        this.currentUser = CacheService.getUser();
        this.workflowActionEnum = WorkflowActions;
        this.workflowActionEnumValue = workflowActionEnumValue;
        this.ldIncludes = _.includes;
        this.submitLabel = submitLabel;
        this.cancelLabel = cancelLabel;
        this.cancelText = cancelText;
        if (workflowActionEnumValue == WorkflowActions.PENDING_MIGRATION) {
            this.teamsFilter = {
                "isFormerTeamMember": false,
                "isFrozen": false,
                "teamType": TeamTypeEnum.STUDENT,
                "teamOrgId": this.currentUser.organizationId
            };
            if (this.additionalParams) {
                Object.keys(this.additionalParams).forEach(k => {
                    this.teamsFilter[k] = this.additionalParams[k];
                })
            }
            this.allTeams = [];
        } else if (_.includes([WorkflowActions.BEGIN_DETERMINATION, WorkflowActions.ASSIGN_SERVICE], workflowActionEnumValue)) {
            this.subjectId = subjectId;
            this.membersLoading = true;
            this.providers = [];
            $_api.getFormProviders(this.assgnId, this.CacheService.getPassword(), "providers").then(
                (s) => {
                    if (!!s) {
                        for (var i = 0; i < s.length; i++) {
                            var tempProvider = new User().deserialize(s[i]);
                            if (!!tempProvider)
                                this.providers.push(tempProvider);
                        }
                    }
                    this.membersLoading = false;
                }, (e) => {
                    console.log(e);
                    this.membersLoading = false;
                });
        }
    }
    cancel = (): void => {
        this.$uibModalInstance.dismiss();
    }

    close = (): void => {
        this.showLoader = "Processing...";
        if (this.workflowActionEnumValue == WorkflowActions.PENDING_MIGRATION && !this.existingTeam) {
            this.subjectId = undefined;
        }
        var formUsers = [];
        if (this.workflowActionEnumValue == WorkflowActions.BEGIN_DETERMINATION || this.workflowActionEnumValue == WorkflowActions.ASSIGN_SERVICE) {
            formUsers = this.providers.map(p => {
                if (p.id == this.currentUser.id) {
                    this.crntUserProvider = true;
                }
                return { "userId": p.id };
            });
        }


        this.$_api.triggerFormWorkflow(this.assgnId, this.CacheService.getPassword(), this.subjectId, this.workflowActionEnumValue, formUsers).then((s) => {
            !!s && (s.crntUserProvider = this.crntUserProvider);
            if (this.workflowActionEnumValue == WorkflowActions.PENDING_MIGRATION) {
                if (this.subjectId) {
                    let subs = this.CacheService.getSubjects();
                    let ind = subs.findIndex(sub => sub.subjectId == this.subjectId);
                    (ind >= 0) && (subs.splice(ind, 1));
                }
            }
            this.$uibModalInstance.close(s);
        }, (e) => {
            this.$uibModalInstance.dismiss(e);
        }).finally(() => {
            this.showLoader = false;
        });
    }

    onProviderOpenClose = (isOpen: boolean) => {
        if (!isOpen) {
            angular.element('#teamMemberList').scope().$select.search = '';
        }
    }

    deselectProvider = (deselectedProvider, $event) => {
        let subId;
        $event.preventDefault();
        $event.stopPropagation();
        if (!!deselectedProvider.person) {
            subId = deselectedProvider.person.id;
        } else {
            subId = deselectedProvider.id;
        }
        this.providers = this.providers.filter((provider) => {
            return provider.id != subId;
        });
    }
}

angular.module('eCareVault.common.popUp')
    .controller('FormWorkflowController', FormWorkflowController);
